<template>
  <div class="chart-container">
    <div class="chart-actions">
      <el-button size="small" @click="exportChart" type="primary">
        <font-awesome-icon icon="download" />
        График татах
      </el-button>
    </div>
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default {
  name: 'ReportChart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    xColumn: {
      type: String,
      default: ''
    },
    yColumn: {
      type: String,
      default: ''
    },
    chartType: {
      type: String,
      default: 'bar'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    data: {
      handler () {
        this.updateChart()
      },
      deep: true
    },
    chartType () {
      this.updateChart()
    },
    xColumn () {
      this.updateChart()
    },
    yColumn () {
      this.updateChart()
    }
  },
  mounted () {
    this.updateChart()
  },
  beforeUnmount () {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    updateChart () {
      if (!this.data || this.data.length === 0 || !this.xColumn || !this.yColumn) {
        return
      }

      if (this.chart) {
        this.chart.destroy()
      }

      const ctx = this.$refs.chartCanvas
      if (!ctx) return

      const labels = this.data.map(row => row[this.xColumn] || '')
      const values = this.data.map(row => parseFloat(row[this.yColumn]) || 0)

      const config = {
        type: this.chartType || 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: this.yColumn,
            data: values,
            backgroundColor: (this.chartType || 'bar') === 'pie' ? this.generateColors(values.length) : 'rgba(54, 162, 235, 0.5)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: (this.chartType || 'bar') !== 'pie'
            ? {
                y: {
                  beginAtZero: true
                }
              }
            : undefined
        }
      }

      this.chart = new Chart(ctx, config)
    },
    generateColors (count) {
      const colors = []
      for (let i = 0; i < count; i++) {
        const hue = (i * 360 / count) % 360
        colors.push(`hsla(${hue}, 70%, 50%, 0.7)`)
      }
      return colors
    },
    exportChart () {
      if (!this.chart) return

      const url = this.chart.toBase64Image()
      const link = document.createElement('a')
      link.download = `chart_${new Date().getTime()}.png`
      link.href = url
      link.click()
    }
  }
}
</script>

<style scoped>
.chart-container {
  margin-top: 20px;
}

.chart-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

canvas {
  max-height: 400px;
}
</style>
